import * as React from 'react';
import { VerificationService } from '@sheerid/jslib-nightly';

interface LogoProps {
    verificationService: VerificationService;
}

const LogoComponent = ({ verificationService }: LogoProps) => {
    const logoUrl = 'logo.svg';

    if (logoUrl) {
        return (
            <div className="sid-logo sid-l-space-top-md">
                <img
                    className="sid-logo__img"
                    alt="Logo"
                    src={logoUrl}
                />
            </div>
        );
    }
    return null;
};

export {  LogoComponent };
